function initCustomSlidersProduct() {
    if (typeof jQuery === 'undefined' || typeof $.fn.slick === 'undefined') return;

    if($('.custom-slider_3').length > 0)
    {
        $('.custom-slider_3').each(function() {
            const $slider_3 = $(this);
            if ($slider_3.hasClass('slick-initialized')) return;
            $slider_3.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                dots: true,
                arrows: false,
                autoplaySpeed: 5000,
                adaptiveHeight: true
            });
        });
    }

  

}

jQuery(document).ready(function($) {

    initCustomSlidersProduct();

    /*jQuery("a.programeaza_intalnire").on("click", function(){
        Tipo.Booking.openWidget(10268704538963);
    });*/

   

    
});

jQuery( window ).on("load", function($) {

    var slickInitialized = false;
    var $grid = jQuery('product-recommendations.related-products .grid');

    function initSliderContentPr() {
        if (!slickInitialized && $grid.length) {
            $grid.slick({
                slidesToShow: 1.5,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: false,
                adaptiveHeight: true,
            });
            slickInitialized = true;
        }
    }

    function destroySliderPr() {
        if (slickInitialized && $grid.hasClass('slick-initialized')) {
            $grid.slick('unslick');
            slickInitialized = false;
        }
    }

    function handleResizeContentPr() {
        var windowWidth = jQuery(window).width();

        if (windowWidth < 749) {
            initSliderContentPr();
        } else {
            destroySliderPr();
        }
    }

    
    jQuery(window).on('resize', handleResizeContentPr);
    setTimeout(function() { 
        handleResizeContentPr();
    }, 500);
});
